import { Pipe, PipeTransform } from '@angular/core';

import { StartersDispensation } from '@ap/ap-interface-apix-hypotheken-berekening';

@Pipe({
    name: 'startersDispensationInfoPipe',
    standalone: true
})
export class StartersDispensationInfoPipe implements PipeTransform {
    transform(contentKey: string, option: StartersDispensation, hasCoApplicant: boolean): string {
        switch (option) {
            case StartersDispensation.YES_BOTH_APPLICANTS:
                return `${contentKey}.yes-both`;
            case StartersDispensation.YES_ONE_OF_APPLICANTS:
                return `${contentKey}.yes-one-of-us`;
            case StartersDispensation.NO_BOTH_APPLICANTS:
                return `${contentKey}.no-both`;
            case StartersDispensation.UNKNOWN_BOTH_APPLICANTS:
                return `${contentKey}.unknown-both`;
            case StartersDispensation.YES_MAIN_APPLICANT:
                return hasCoApplicant ? `${contentKey}.yes-main-with-partner` : `${contentKey}.yes-main`;
            case StartersDispensation.NO_MAIN_APPLICANT:
                return hasCoApplicant ? `${contentKey}.no-main-with-partner` : `${contentKey}.no-main`;
            case StartersDispensation.UNKNOWN_MAIN_APPLICANT:
                return hasCoApplicant ? `${contentKey}.unknown-main-with-partner` : `${contentKey}.unknown-main`;
            case StartersDispensation.YES_CO_APPLICANT:
                return `${contentKey}.yes-co`;
            case StartersDispensation.NO_CO_APPLICANT:
                return `${contentKey}.no-co`;
            case StartersDispensation.UNKNOWN_CO_APPLICANT:
                return `${contentKey}.unknown-co`;
            default:
                return `${contentKey}.unknown-both`;
        }
    }
}
